import { z } from 'zod';
export const isPlayableVideoUrl = (url) => {
    if (url === null)
        return true;
    return url.startsWith('https://');
};
export const zPlayableVideoUrl = z
    .string()
    .nullable()
    .refine(isPlayableVideoUrl, {
    message: 'mustBeHttpsUrl',
});
const YOUTUBE_HOSTNAMES = ['youtube.com', 'youtu.be', 'youtube.googleapis.com', 'youtube-nocookie.com'];
export const isYoutubeUrl = (url) => {
    try {
        const { hostname } = new URL(url);
        return YOUTUBE_HOSTNAMES.some((h) => hostname === h || hostname.endsWith('.' + h));
    }
    catch {
        return false;
    }
};
export const canPlayVideoUrl = (url) => !isYoutubeUrl(url) || !!getYoutubeVideoId(url);
export const getYoutubeVideoId = (url) => {
    let ID = '';
    const urlParts = url
        .replace(/(>|<)/gi, '')
        .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)/);
    if (urlParts[2] !== undefined) {
        const idParts = urlParts[2].split(/[^0-9a-z_\-]/i);
        ID = idParts[0] || '';
    }
    else {
        ID = '';
    }
    return ID;
};
export const getYoutubePreviewThumbnail = (youtubeUrl) => {
    const videoId = getYoutubeVideoId(youtubeUrl);
    const imgUrl = 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg';
    return imgUrl;
};
export const transformVideoUrlForPlayer = (url) => {
    if (url.includes('dropbox.com')) {
        return convertDropboxUrlToDirectDownload(url);
    }
    return url;
};
/**
 * Converts Dropbox sharing URLs to direct download URLs for video playback.
 * Dropbox sharing URLs need to have raw=1 to work as direct download links for video playback.
 * The raw=1 parameter allows the video to be streamed directly without Dropbox's web interface.
 */
const convertDropboxUrlToDirectDownload = (url) => {
    try {
        const urlObj = new URL(url);
        // Set raw=1 for direct video streaming (required for video playback)
        urlObj.searchParams.set('raw', '1');
        return urlObj.toString();
    }
    catch (e) {
        // If URL parsing fails, return original URL
        return url;
    }
};
//# sourceMappingURL=utils.js.map